module.exports = __webpack_public_path__ + "static/media/socialImage-v2.bbaee911.png";